export function b64DecodeUnicode(value) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(value).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}
